// src/pages/Users.js
import { useState, useEffect } from "react";
import axios from "axios";
import { BACKEND_BASE } from "./constant";
import "./Users.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Applicants = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BACKEND_BASE}/getApplicants`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const formatESTDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      timeZone: "America/New_York",
      hour12: true,
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id],
    );
  };

  const handleAccept = () => processApplicants("A");
  const handleReject = () => processApplicants("R");

  const processApplicants = async (code) => {
    const selectedEmails = data
      .filter((item) => selectedRows.includes(item._id))
      .map((item) => item.email);

    try {
      await axios.post(`${BACKEND_BASE}/processApplicants`, {
        code,
        emails: selectedEmails,
      });

      // Refresh data
      const updatedResponse = await axios.get(`${BACKEND_BASE}/getApplicants`);
      setData(updatedResponse.data);
      setSelectedRows([]);
    } catch (error) {
      console.error("Error processing applicants:", error);
    }
  };

  // Safe render function for nested premium structure
  const renderValue = (value, field) => {
    if (value === null || value === undefined) return "N/A";

    // Premium plan
    if (field === "Plan") return value?.plan || "N/A";

    // Premium appliedAt
    if (field === "AppliedAt")
      return value?.appliedAt ? formatESTDate(value.appliedAt) : "N/A";

    // Premium questionnaire (optional)
    if (field === "Questionnaire")
      return value?.questionnaire ? JSON.stringify(value.questionnaire) : "N/A";

    if (Array.isArray(value)) return value.join(", ");

    if (typeof value === "object") return JSON.stringify(value);

    return value;
  };

  return (
    <div className="admin-container">
      <Button
        className="sticky-back-button"
        onClick={() => navigate("/")}
        style={{ backgroundColor: "rgb(72, 39, 110)" }}
      >
        Back
      </Button>

      {loading ? (
        <p className="text-center my-2">Loading...</p>
      ) : data.length > 0 ? (
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>Select</th>
                <th>Plan</th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Gender</th>
                <th>Age</th>
                <th>Intention</th>
                <th>Height</th>
                <th>Job Title</th>
                <th>Personality</th>
                <th>Hobbies</th>
                <th>Drinks</th>
                <th>Applied At</th>
                <th>Questionnaire</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item._id}>
                  <td>
                    <input
                      type="checkbox"
                      onChange={() => handleSelectRow(item._id)}
                      checked={selectedRows.includes(item._id)}
                    />
                  </td>
                  <td>{renderValue(item.premium, "Plan")}</td>
                  <td>{renderValue(item.email)}</td>
                  <td>{renderValue(item.firstName)}</td>
                  <td>{renderValue(item.lastName)}</td>
                  <td>{renderValue(item.gender)}</td>
                  <td>{renderValue(item.age)}</td>
                  <td>{renderValue(item.intention)}</td>
                  <td>{renderValue(item.height)}</td>
                  <td>{renderValue(item.jobTitle)}</td>
                  <td>{renderValue(item.personality)}</td>
                  <td>{renderValue(item.hobbies)}</td>
                  <td>{renderValue(item.drinks)}</td>
                  <td>{renderValue(item.premium, "AppliedAt")}</td>
                  <td>{renderValue(item.premium, "Questionnaire")}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="action-buttons my-3">
            <Button
              style={{ backgroundColor: "rgb(72, 39, 110)" }}
              onClick={handleAccept}
              disabled={selectedRows.length === 0}
            >
              Accept
            </Button>
            <Button
              style={{ backgroundColor: "rgb(72, 39, 110)" }}
              onClick={handleReject}
              disabled={selectedRows.length === 0}
              className="mx-2"
            >
              Reject
            </Button>
          </div>
        </div>
      ) : (
        <p>Empty Data</p>
      )}
    </div>
  );
};

export default Applicants;
